// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"2e939bf2","administration":"b3ac53eb"}[chunkId] + ".chunk.js";
};